export default __webpack_public_path__ + "static/media/F5.08f5fcc8.mp3";